import React from 'react';

export default class Toggle extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }
    onChange(e) {
        this.props.onChange(this.props.name, e.target.checked);
    }
    render() {
        return (
            <div className="toggle-container inline-block">
                <input type="checkbox"
                    name={this.props.name}
                    checked={this.props.value}
                    id={`toggle-${this.props.id}`}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    className="cbx hidden input" />
                <label htmlFor={`toggle-${this.props.id}`} className={`toggle input ${this.props.disabled ? 'disabled' : ''}`}></label>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/Toggle.jsx